import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Megaphone } from "lucide-react";
import { noticeImgUrl } from "@/components/NoticeSettings";

const isActive = (n) =>
  !!n?.enabled &&
  ((n.mode === "oven" && n.items?.length) || (n.mode === "image" && n.image) || ((n.mode || "text") === "text" && n.text));

function OvenContent({ items }) {
  return (
    <>
      <DialogTitle className="font-display font-black text-2xl tracking-tight">🍕 Saindo do forno agora!</DialogTitle>
      <DialogDescription className="sr-only">Pizzas disponíveis agora</DialogDescription>
      <ul className="divide-y divide-border" data-testid="notice-popup-oven-list">
        {items.map((it, idx) => (
          <li key={idx} className="flex items-center gap-3 py-2.5" data-testid={`notice-popup-oven-item-${idx}`}>
            <span className="font-display font-black text-primary text-xl min-w-[3rem]">{it.qty}x</span>
            <span className="text-base font-medium">{it.name}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

function TextContent({ text }) {
  return (
    <>
      <div className="flex items-center gap-2">
        <span className="w-9 h-9 rounded-full bg-primary/10 text-primary flex items-center justify-center">
          <Megaphone className="w-4 h-4" />
        </span>
        <DialogTitle className="font-display font-black text-xl tracking-tight">Aviso</DialogTitle>
      </div>
      <DialogDescription data-testid="notice-popup-text" className="text-base text-foreground whitespace-pre-line leading-relaxed">
        {text}
      </DialogDescription>
    </>
  );
}

export default function NoticePopup({ notice }) {
  const [open, setOpen] = useState(false);
  const active = isActive(notice);
  const isImage = active && notice.mode === "image";

  useEffect(() => {
    if (!active) return undefined;
    const t = setTimeout(() => setOpen(true), 3000);
    return () => clearTimeout(t);
  }, [active]);

  if (!active) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="notice-popup" className={`rounded-2xl ${isImage ? "w-fit max-w-[94vw] p-4 pt-12" : "max-w-md"}`}>
        {notice.mode === "oven" && <OvenContent items={notice.items} />}
        {isImage && (
          <>
            <DialogTitle className="sr-only">Aviso</DialogTitle>
            <DialogDescription className="sr-only">Cartaz</DialogDescription>
            <img src={noticeImgUrl(notice.image)} alt="Aviso" data-testid="notice-popup-image"
              className="block mx-auto w-auto h-auto max-w-[calc(94vw-2rem)] max-h-[70vh] object-contain rounded-lg" />
          </>
        )}
        {(notice.mode || "text") === "text" && <TextContent text={notice.text} />}
        <button onClick={() => setOpen(false)} data-testid="notice-popup-close-btn"
          className="w-full rounded-full bg-primary text-primary-foreground py-3 font-semibold hover:bg-primary/90 transition-colors">
          Fechar
        </button>
      </DialogContent>
    </Dialog>
  );
}
